<template>
  <div class="SlidePagination lxn-w100 lxn-h100">
    <div @click="$emit('click', index)" v-for="(bullet,index) in bullets" :key="index" :class="bullet.bulletClass" class="SlidePagination-bullet lxn-h100 lxn-float-left lxn-border-round" :style="bullet.bulletStyle">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'SlidePagination',
  components: {
  },
  data: function() {
    return {
    }
  },
  props: {
    slideCount: Number,
    selectedSlide: Number
  },
  computed: {
    bullets: function () {
      var bullets = [];
      var widthCoef = 2;
      var bulletClass = '';
      for(var i = 0; i < this.slideCount; i++){
        widthCoef = i == this.selectedSlide ? 4 : 2;
        bulletClass = i == this.selectedSlide ? 'selected' : '';
        bullets.push({
          index: i,
          bulletStyle: "margin-right: " + this.referenceWidth + "%;width: " + widthCoef*this.referenceWidth + "%;",
          bulletClass: bulletClass
        });
      }
      return bullets;
    },
    referenceWidth: function () {
      return (100 / ((this.slideCount + 1)*2 + this.slideCount - 1));
    },
  },
  methods: {
  }
}
</script>

<style>
  .SlidePagination-bullet {
    background-color: #D5E6F0;
    transition: all 300ms ease-in;
  }
  .SlidePagination-bullet.selected {
    background-color: #1EA5DE;
  }
  .SlidePagination-bullet:last-child {
    margin-right: 0 !important;
  }
</style>
